module.exports = __webpack_public_path__ + "img/8b5d86b.jpeg";